import { ORGANIZATION_TYPES, ORGANIZATION_TYPES_SHORT } from './constants';

export const mapOrganizationTypeToShort = () => {
  return Object.keys(ORGANIZATION_TYPES).reduce((map, key) => {
    if (ORGANIZATION_TYPES_SHORT[key]) {
      map[ORGANIZATION_TYPES[key]] = ORGANIZATION_TYPES_SHORT[key];
    }
    return map;
  }, {});
};

export const mapOrganizationShortToType = () => {
  return Object.keys(ORGANIZATION_TYPES_SHORT).reduce((map, key) => {
    if (ORGANIZATION_TYPES[key]) {
      map[ORGANIZATION_TYPES_SHORT[key]] = ORGANIZATION_TYPES[key];
    }
    return map;
  }, {});
};
